import { clientBase } from "../common";

export const getItems = () => {
  return clientBase(
    `v1/getAllCategories?proyect_id=${process.env.VUE_APP_PROYECT_ID}`,
    "GET"
  );
};
